import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import Input from 'ac-components/ac-ipt';
import Select from 'ac-components/select';
import styles from './styles.scss';
import cls from '@utils/css-select';
import Cropper from 'react-cropper';
import 'cropperjs/dist/cropper.css';
import { OperationalModal } from 'ac-components/modal';
import FileSelect from './file-select';
import { toast } from 'components/dialogs';
import resetPassword, { SendSmsBtn } from 'containers/ac-containers/reset-password';
import { updateUserInfo } from '@services/my-home';
import Alert from 'ac-components/alert';
import ACLocalStorage from '@utils/ac-localStorage';
import { Address, UserInfo } from 'states/interface';
import { UploadMethod, uploadWithAliOss } from '@utils/upload';
import { emailCodeSent, getUserInfo } from '@services/login';
import { dataURLtoFile } from '@utils/fileTransfer'
import { getAgeOrBirth } from 'pages/offical/personal/const';
import { sendEvent } from '@core/track';
import { EditFormRef } from 'pages/offical/personal/components/profile-info/main';
import { _checkEmpty, _checkValidEmail, useCodeSentCountdown } from 'containers/ac-containers/login/login';
import { useTranslation, UseTranslationProps } from 'hooks/use-translation';
import { _checkAccount } from 'containers/ac-containers/login/signup';

const userInfo: UserInfo | undefined = ACLocalStorage.getUserInfo()

const cx = cls(styles)
let modalClose: { (): any; (params?: any): void } | null = null

export type AvatarEditProps = {
	avatar: string;
}
export type BaseInfoEditFormProps = {
	userName: string;
	birthday: string;
}
export type EmailEditFormProps = {
	email: string;
}
export interface AddrEditFormProps {
	addressInfo: {
		address?: string;
	} | null;
}

type Age = {
	id: number;
	name: string;
}
const ageList: Age[] = [];
for (let i = 3; i <= 18; i++) {
	ageList.push({ id: i, name: i + '' })
}

// 头像编辑
let getCropperData: () => string
function AvatarEdit(props: AvatarEditProps) {
	const { avatar = '' } = props
	const [image, setImage] = useState(avatar);
	// const [cropData, setCropData] = useState("#");
	const [cropper, setCropper] = useState<any>();
	const { transData } = useTranslation('profile')
	const getRoundedCanvas = function (sourceCanvas: HTMLCanvasElement) {
		const canvas: HTMLCanvasElement = document.createElement('canvas');
		const context: CanvasRenderingContext2D | null = canvas.getContext('2d');
		const width = sourceCanvas.width;
		const height = sourceCanvas.height;

		canvas.width = width;
		canvas.height = height;
		if (context) {
			context.imageSmoothingEnabled = true;
			context.drawImage(sourceCanvas, 0, 0, width, height);
			context.globalCompositeOperation = 'destination-in';
			context.beginPath();
			context.arc(width / 2, height / 2, Math.min(width, height) / 2, 0, 2 * Math.PI, true);
			context.fill();
		}
		return canvas;
	}
	getCropperData = () => {
		if (!cropper) return ''
		const croppedCanvas: HTMLCanvasElement = cropper.getCroppedCanvas();
		const roundedCanvas = getRoundedCanvas(croppedCanvas);
		return roundedCanvas.toDataURL();
	};

	return (
		<div className={cx('cropper-wrap')}>
			<Cropper
				className={cx('cropper-box')}
				// zoomTo={0.5}
				initialAspectRatio={1}
				aspectRatio={1}
				preview=".preview-box"
				src={image}
				viewMode={1}
				minCropBoxHeight={164}
				minCropBoxWidth={164}
				// background={true}
				// responsive={true}
				// autoCropArea={1}
				cropBoxResizable={false}
				checkOrientation={false} // https://github.com/fengyuanchen/cropperjs/issues/671
				onInitialized={(instance) => {
					setCropper(instance);
				}}
				guides={true}
			/>
			<div className={cx('preview-box_wrap')}>
				<div className={`preview-box ${cx('preview-box_')}`}>
				</div>
				<span className={cx('preview-title')}>{transData.preview}</span>
			</div>
		</div>
	)
}

// 姓名，年龄 编辑
type BaseInfoFormValidate = {
	val?: BaseInfoEditFormProps;
	validate?: boolean;
}
let baseInfoFormValidate: BaseInfoFormValidate = {}
function BaseInfoEditForm(props: BaseInfoEditFormProps) {
	const [userName, setUserName] = useState(props.userName || '')
	const tempAge = ageList.filter(item => item.name === getAgeOrBirth(undefined, props.birthday))[0]
	const [age, setAge] = useState<Age>(tempAge || {});
	const [birthday, setBirthday] = useState(props.birthday || '')
	const [nameErr, setNameErr] = useState('')
	const { transData, t } = useTranslation('profile')
	const changeBaseInfoFormValidate = (value: { userName?: string; birthday?: string }, validate: boolean) => {
		baseInfoFormValidate = {
			val: { userName, birthday, ...value },
			validate
		}
	}

	const checkNameEmpty = (val: string) => {
		const res = val !== ''
		setNameErr(res ? '' : t('login.required'))
		return res
	}
	const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const val = e.target.value
		setUserName(val)
		checkNameEmpty(val)
	}

	const onAgeChange = (age: Age) => {
		setAge(age)
		setBirthday(getAgeOrBirth(age.name, undefined))
	}

	useEffect(() => {
		changeBaseInfoFormValidate({ userName }, !nameErr)
	}, [userName])

	useEffect(() => {
		changeBaseInfoFormValidate({ birthday }, !nameErr)
	}, [age])

	useEffect(() => {
		changeBaseInfoFormValidate({ userName, birthday }, !nameErr)
	}, [nameErr])

	return (
		<div className={cx('edit-form')}>
			<div className={cx('form-item')}>
				<p className={cx('label')}>{t('login.nameText')}</p>
				<Input
					className={cx('edit-ipt')}
					value={userName}
					placeholder={t('login.nameText')}
					error={nameErr}
					onChange={handleNameChange} />
			</div>
			<div className={cx('form-item')}>
				<p className={cx('label')}>{t('login.age')}</p>
				<div>
					<Select
						list={ageList}
						menuTitle={t('login.ageText')}
						placeholder={t('login.sAge')}
						allowSearch={false}
						selected={age}
						onChange={onAgeChange}
					/>
				</div>
			</div>
		</div>
	)
}

// 邮箱编辑
export const EmailEditForm = forwardRef(function (props: EmailEditFormProps, ref: React.Ref<EditFormRef>) {
	const [emailVal, setEmailVal] = useState(props.email || '')
	const [emailErr, setEmailErr] = useState('')
	const [codeVal, setCodeVal] = useState('')
	const [codeErr, setCodeErr] = useState('')
	const [errorTip, setErrorTip] = useState('')
	const [warnTip, setWarnTip] = useState('')
	const [codeSentTip, setCodeSentTip] = useState('')
	const { timerCount, countdownHandler } = useCodeSentCountdown(120)
	const [step, setStep] = useState(1)
	const [updateLoading, setUpdateLoading] = useState(false)
	const [codeSentLoading, setCodeSentLoading] = useState(false)
	const { transData, t } = useTranslation('profile')
	function handleWarnTipClose () {
		setWarnTip('')
	}
	function renderCodeSentTip () {
		return (
			<Alert type='success' className={cx('code-sent-tip')} duration={5} onClose={() => setCodeSentTip('')}>
				<p>{codeSentTip}</p>
			</Alert>
		)
	}

	const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setEmailVal(e.target.value.trim())
		setEmailErr('')
		setErrorTip('')
		setWarnTip('')
	}

	const handleCodeChange = (e: React.FocusEvent<HTMLInputElement>) => {
		setCodeVal(e.target.value.trim())
		setCodeErr('')
		setErrorTip('')
		setWarnTip('')
	}

	const getCode = async () => {
		try {
			setCodeSentLoading(true)
			const checkRes = await _checkAccount({ email: emailVal, scene: 4 }, () => {
				setCodeSentLoading(false)
				setWarnTip('The email is already in use please try another')
			})
			if (checkRes?.data === true) return
			const sentRes = await emailCodeSent({ email: emailVal, scene: 4 })
			setCodeSentLoading(false)
			if (sentRes.data) {
				if (step === 1) setStep(step + 1)
				setCodeSentTip(`Your primary email address has been updated. You should receive a confirmation email to ${emailVal}.`)
				countdownHandler() // 开启倒计时
			}
		} catch (e) {
			setErrorTip(e?.errMsg)
			setCodeSentLoading(false)
		}
	}
	const handleCodeSentClick = () => {
		sendEvent({ eventId: 'changemail_resendcode' })
		const emailCheckRes = !_checkEmpty(emailVal, setEmailErr) && _checkValidEmail(emailVal, setEmailErr)
		if (timerCount || !emailCheckRes || codeSentLoading) return
		getCode()
	}

	const stepOneSubmit = () => {
		const emailCheckRes = !_checkEmpty(emailVal, setEmailErr) && _checkValidEmail(emailVal, setEmailErr)
		if (timerCount || !emailCheckRes || codeSentLoading) return
		getCode()
	}

	const stepTwoSubmit = async (cb?: () => void) => {
		sendEvent({ eventId: 'changemail_savenewmail' })
		const emailCheckRes = !_checkEmpty(emailVal, setEmailErr) && _checkValidEmail(emailVal, setEmailErr)
		const codeCheckRes = _checkEmpty(codeVal, setCodeErr)
		if (!emailCheckRes || codeCheckRes || updateLoading) return
		try {
			setUpdateLoading(true)
			const res: Record<string, any> = await updateUserInfo({ email: emailVal || '', updateEmail: true, validateCode: codeVal })
			if (res.code === '0') {
				await getUserInfo()
				typeof cb === 'function' && cb()
				toast({ message: 'Save successfully!' })
			} else {
				setErrorTip(res.message || 'Serve error')
			}
		} finally {
			setUpdateLoading(false)
		}
	}

	useImperativeHandle(ref, () => {
		return {
			async validate(cb?: () => void) {
				if (step === 1) stepOneSubmit()
				if (step === 2) stepTwoSubmit(cb)
			}
		}
	})

	return (
		<div className={cx('edit-form')}>
			{
				(errorTip || warnTip || codeSentTip) && <div className={cx('alert-wrap')}>
					{warnTip && <Alert type='warn' duration={5} onClose={handleWarnTipClose}>{warnTip}</Alert>}
					{codeSentTip && renderCodeSentTip()}
					{errorTip && <Alert type='error'>{errorTip}</Alert>}
				</div>
			}
			<div className={cx('form-item')}>
				<p className={cx('label')}>{transData.email}</p>
				<Input
					className={cx('edit-ipt')}
					value={emailVal}
					placeholder={transData.email}
					error={emailErr}
					// onBlur={handleEmailBlur}
					onChange={handleEmailChange} />
			</div>
			{step === 2 && <div className={cx('form-item')}>
				<p className={cx('label')}>Code</p>
				<Input
					className={cx('edit-ipt')}
					type='number'
					value={codeVal}
					placeholder='Code'
					error={codeErr}
					onChange={handleCodeChange}
					suffix={<SendSmsBtn onClick={handleCodeSentClick} count={timerCount} />}
				/>
			</div>}
		</div>
	)
})
// 地址编辑
export const AddrEditForm = forwardRef(function (props: AddrEditFormProps, ref: React.Ref<EditFormRef | null>) {
	const [addrVal, setAddrlVal] = useState(props.addressInfo?.address || '')
	const [addressErr, setAdressErr] = useState('')
	const { transData, t } = useTranslation('profile')

	const checkEmpty = (val: string) => {
		const res = val !== ''
		setAdressErr(val !== '' ? '' : t('login.required'))
		return res
	}

	const handleAddrChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const val = e.target.value
		setAddrlVal(val)
		checkEmpty(val)
	}

	useImperativeHandle(ref, () => {
		return {
			async validate(cb?: () => void) {
				if (!checkEmpty(addrVal)) return
				await updateUserInfo({ addressInfo: { ...props.addressInfo, address: addrVal } })
				await getUserInfo()
				typeof cb === 'function' && cb()
			}
		}
	})

	return (
		<div className={cx('edit-form')}>
			<div className={cx('form-item')}>
				<p className={cx('label')}>{transData.address}</p>
				<Input
					className={cx('edit-ipt')}
					value={addrVal || ''}
					placeholder={transData.address}
					error={addressErr}
					onChange={handleAddrChange} />
			</div>
		</div>
	)
})

export const changeAvatar = function (transData: any, t: any) {
	let fileSelect: FileSelect | null = null
	let editLoading = false
	const handleModalOk = async () => {
		try {
			editLoading = true
			const base64File = getCropperData()
			const file = dataURLtoFile(base64File, `${userInfo?.userId || ''}_avatar_${new Date().getTime()}`)
			const ossUrl = await uploadWithAliOss({ file, type: file.type, uploadMethod: UploadMethod.multipartUpload, quality: 50 })
			await updateUserInfo({
				avatar: ossUrl || ''
			})
			await getUserInfo()
			modalClose && modalClose()
			Alert.success(transData.update, {
				container: document.getElementById('personal-alert-wrap'),
			})
		} finally {
			editLoading = false
		}
	}
	function fileChange(file: File) {
		if (fileSelect && !fileSelect.checkFileType(file.type)) {
			toast({
				message: transData.typeError,
			})
			return
		}
		if (fileSelect && !fileSelect.checkFileSize(file.size)) {
			toast({
				message: transData.sizeError,
			})
			return
		}

		const reader = new FileReader();
		reader.onload = () => {
			const base64Pic: string = reader.result + ''
			modalClose = OperationalModal.show({
				title: transData.editImg,
				size: 'mini',
				// okProps: {loading: editLoading},
				onOk: handleModalOk,
				cancelText: transData.cancel,
				okText: transData.ok,
				onCancel: () => modalClose && modalClose(),
				content: <AvatarEdit avatar={base64Pic} />
			})
		};
		reader.readAsDataURL(file);
	}
	fileSelect = new FileSelect('image/png', 5 * 1024, fileChange)
}

export const changeBaseInfo = function ({ userName, birthday }: BaseInfoEditFormProps, transData: any) {
	let editLoading = false

	const handleModalOk = async () => {
		if (!baseInfoFormValidate.validate) return
		try {
			editLoading = true
			await updateUserInfo({ ...baseInfoFormValidate.val })
			await getUserInfo()
			modalClose && modalClose()
			Alert.success(transData.update, {
				container: document.getElementById('personal-alert-wrap'),
			})
		} finally {
			editLoading = false
		}
	}
	modalClose = OperationalModal.show({
		title: transData.editInfo,
		size: 'mini',
		okProps: { loading: editLoading },
		onOk: handleModalOk,
		cancelText: transData.cancel,
		okText: transData.ok,
		onCancel: () => modalClose && modalClose(),
		content: <BaseInfoEditForm {...{ userName, birthday }} />
	})
}

// export const changeEmail = function (email: string) {
//
// 	sendEvent({
// 		eventId: 'EAF_1d1e4c019539bc4d',
// 	})
//
// 	let editLoading = false
//
// 	const handleModalOk = () => {
// 		EmailEditForm.prototype.formCheck()
// 		clearTimeout(changeEmail.prototype.timerId)
// 		changeEmail.prototype.timerId = setTimeout(async () => {
// 			if (!emailFormValidate.validate) return
// 			try {
// 				editLoading = true
// 				await updateUserInfo({email: emailFormValidate.val || ''})
// 				await getUserInfo()
// 				modalClose && modalClose()
// 				Alert.success('Update success', {
// 					container: document.getElementById('personal-alert-wrap'),
// 				})
// 			} finally {
// 				editLoading = false
// 			}
// 		}, 100) // 移动端 0 还是不行
// 	}
// 	modalClose = OperationalModal.show({
// 		title: 'Edit Email',
// 		size: 'mini',
// 		okProps: {loading: editLoading},
// 		onOk: handleModalOk,
// 		onCancel: () => modalClose && modalClose(),
// 		content: <EmailEditForm email={email} />
// 	})
// }

// export const changeAddress = function (addressInfo: Address) {
// 	sendEvent({
// 		eventId: 'EAF_cd5bbd3ed2a19b21'
// 	})
// 	let editLoading = false
//
// 	const handleModalOk = () => {
// 		AddrEditForm.prototype.formCheck()
// 		clearTimeout(changeAddress.prototype.timerId)
// 		changeAddress.prototype.timerId = setTimeout(async () => {
// 			if (!addrFormValidate.validate) return
// 			try {
// 				editLoading = true
// 				await updateUserInfo({addressInfo: { ...addressInfo, address: addrFormValidate.val }})
// 				await getUserInfo()
// 				modalClose && modalClose()
// 				Alert.success('Update success', {
// 					container: document.getElementById('personal-alert-wrap'),
// 				})
// 			} finally {
// 				editLoading = false
// 			}
// 		}, 100) // 移动端 0 还是不行
// 	}
//
// 	modalClose = OperationalModal.show({
// 		title: 'Edit Address',
// 		size: 'mini',
// 		okProps: {loading: editLoading},
// 		onOk: handleModalOk,
// 		onCancel: () => modalClose && modalClose(),
// 		content: <AddrEditForm address={addressInfo.address || ''} />
// 	})
// }

export const changePwd = function (trans: UseTranslationProps) {
	sendEvent({
		eventId: 'EAF_8b68286633a9ae2e'
	})
	resetPassword(trans)
}
